import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonDataService } from '../../appDataServices/commonDataService';
import { ManageCardsServiceService } from '../../credit-card-management/manage-cards-service.service';
import { RouteNavigationService } from '../../_services/routeNavigationService';

@Component({
  selector: 'app-select-added-cards-paymetric',
  templateUrl: './select-added-cards-paymetric.component.html',
  styleUrls: ['./select-added-cards-paymetric.component.scss'],
})
export class SelectAddedCardsPaymetricComponent implements OnInit {
  @Input() data: any;
  addedCardsForSeller = [];
  paymentDone = false;
  paymentClicked = false;
  paymentResp;
  paymentErrorResp;
  card;
  maxLength = 0;
  loading = false;
  constructor(
    private manageCardsService: ManageCardsServiceService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    this.getSavedCardsForSelectedSeller();
  }


  getSavedCardsForSelectedSeller() {
    this.loading = true;
    this.manageCardsService.getSavedCardsForBuyerForSelectedSeller(true).subscribe(data => {
      this.loading = false;
      this.addedCardsForSeller = data;
    }, () => {
      this.loading = false;
    });
  }

  enterCvv(card){
    this.paymentClicked = true;
    this.card = card;
   
  }
  

  selectCardForPayment() {
    // this.loading = true;
    var card = this.card
    this.loading = true;
    this.manageCardsService.doPayment(card, this.data.amt).subscribe(data => {
      this.paymentClicked = false;
      this.paymentDone = true;
      this.loading = false;
      console.log(data);
      
    }, () => {
      this.loading = false;
    });
  }

}
